module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/sm-b57f66050d777f87e0a5ca189c484b15.svg";